import OtrivinChatbot from "./Components/Otrivin/OtrivinChatbot.svelte";

customElements.define(
    // I recommend prefixing your custom elements, but for this example
    // I'm keeping it simple.
    "hw-otrivin-chatbot",
    class extends HTMLElement {
        _element

        constructor() {
            super();

            // Create the shadow root.
            const shadowRoot = this.attachShadow({ mode: "open" });

            // Instantiate the Svelte Component
            this._element = new OtrivinChatbot({
                // Tell it that it lives in the shadow root
                target: shadowRoot,
                props: {
                    productsData: this.getAttribute('products'),
                },
            });
        }
        disconnectedCallback () {
            this._element?.$destroy();
        }
    }
);
